import { render, staticRenderFns } from "./shipowner.vue?vue&type=template&id=0cb0cf0a&scoped=true&"
import script from "./shipowner.vue?vue&type=script&lang=js&"
export * from "./shipowner.vue?vue&type=script&lang=js&"
import style0 from "./shipowner.vue?vue&type=style&index=0&id=0cb0cf0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb0cf0a",
  null
  
)

export default component.exports